module.exports = __webpack_public_path__ + "img/atp07.2552c74f.jpg";